import axios from 'axios'

const state = {
  transactions: [],
  loading: false,
  error: null
}

const getters = {
  allTransactions: state => state.transactions,
  isLoading: state => state.loading,
  error: state => state.error
}

const actions = {
  async fetchCredits({ commit }) {
    try {
      const response = await axios.get('/api/credits', { withCredentials: true })
      // response.data contains subscription info directly now
      commit('auth/UPDATE_CREDITS', response.data, { root: true })
      return { success: true, credits: response.data }
    } catch (error) {
      return { success: false, error: error.response ? error.response.data.error : 'Failed to fetch credits' }
    }
  },

  async fetchTransactions({ commit }) {
    commit('SET_LOADING', true)

    try {
      const response = await axios.get('/api/credits/transactions', { withCredentials: true })
      commit('SET_TRANSACTIONS', response.data.transactions)
      return { success: true }
    } catch (error) {
      const errorMessage = error.response ? error.response.data.error : 'Failed to fetch transactions'
      commit('SET_ERROR', errorMessage)
      return { success: false, error: errorMessage }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async purchaseCredits({ commit, dispatch }, { amount, paymentReference }) {
    try {
      // Use new invoices endpoint
      const response = await axios.post('/api/invoices', {
        credits_amount: amount,
        reference: paymentReference // Optional, backend generates one too
      }, { withCredentials: true })

      // Invoice created (PENDING). Do not update balance yet.

      return {
        success: true,
        message: response.data.message,
        invoice: response.data.invoice
      }
    } catch (error) {
      return { success: false, error: error.response ? error.response.data.error : 'Failed to purchase credits' }
    }
  },

  async simulatePayment({ dispatch }, { invoiceId }) {
    try {
      const response = await axios.post('/api/webhooks/payment', {
        invoice_id: invoiceId,
        status: 'paid'
      })

      // If payment successful, refresh credits
      if (response.data.success || response.data.message === 'Invoice already processed') {
        await dispatch('fetchCredits')
        await dispatch('fetchTransactions')
      }
      return { success: true }
    } catch (error) {
      return { success: false, error: error.response ? error.response.data.error : 'Payment simulation failed' }
    }
  }
}

const mutations = {
  SET_TRANSACTIONS(state, transactions) {
    state.transactions = transactions
  },

  SET_LOADING(state, status) {
    state.loading = status
  },

  SET_ERROR(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}